"use client";

import { redirect, useParams } from "next/navigation";
import { useEffect } from "react";

export default function PrivacyPoliciesRedirect() {
	const params = useParams();

	useEffect(() => {
		switch (window.location.hash) {
			case "#mobile-policy-patient":
				redirect("/privacypolicies/?privacy-policy=mobile-policy-patient");
				break;
			case "#mobile-policy-provider":
				redirect("/privacypolicies/?privacy-policy=mobile-policy-provider");
				break;
			default:
				redirect("/privacypolicies");
				break;
		}
	}, [params]);

	return <div></div>;
}

// https://github.com/vercel/next.js/discussions/49465
// https://developer.mozilla.org/en-us/docs/Web/API/URL/hash

// /about/privacypolicies#epic-privacy-policy
// /about/privacypolicies#mobile-policy-patient
// /about/privacypolicies#mobile-policy-provider
